import React from 'react'
import { Image } from 'src/components/ui/Image'
import { Link } from 'gatsby'

interface InsuranceMainBannerSectionDataProps {
  title: string
  subTitle?: string
  description?: string
  buttonText?: string
  buttonLinkAction?: string
  imageDesktop: string
  imageMobile?: string
}

const InsuranceMainBannerSectionData: React.FC<
  InsuranceMainBannerSectionDataProps
> = ({
  title,
  subTitle,
  description,
  buttonText,
  buttonLinkAction,
  imageDesktop,
  imageMobile,
}) => {
  return (
    <section className="w-full max-w-[1440px] mx-auto flex flex-col-reverse md:flex-row items-center justify-between md:gap-0">
      <div className="w-full md:w-1/2 flex align-self-center items-center justify-center">
        <div className="w-full flex flex-col justify-center max-w-xl p-4 md:p-9">
          <h2 className="hidden md:block text-3xl md:text-4xl font-bold text-[#101010] mb-4">
            {title}
          </h2>
          {subTitle && (
            <h3 className="text-base md:text-lg font-medium md:font-bold text-[#101010] mb-2">
              {subTitle}
            </h3>
          )}
          {description && (
            <p className="md:text-base text-sm font-normal text-[#616161] mb-6">
              {description}
            </p>
          )}
          {buttonText && buttonLinkAction && (
            <Link
              to={buttonLinkAction}
              className="mx-auto md:mx-0 flex items-center justify-center text-center font-semibold text-white bg-[#2F4ACB] rounded-full
               w-full sm:max-w-fit h-[44px] text-sm md:text-base sm:px-5"
            >
              {buttonText}
            </Link>
          )}
        </div>
      </div>
      <div className="w-full md:w-1/2 flex justify-center items-center md:justify-end md:pl-8">
        <Image
          src={imageMobile ?? imageDesktop}
          srcSet={
            imageMobile && imageDesktop
              ? `${imageMobile} 767w, ${imageDesktop} 768w`
              : undefined
          }
          alt={title}
          className="w-full h-auto md:w-[720px] md:h-[515px] object-cover md:object-contain"
        />
      </div>
    </section>
  )
}

export default InsuranceMainBannerSectionData
